import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TargetService } from '../../services/target.service';
import { Program } from '../../interfaces/program.model';
import { TreeListItem } from '../../interfaces/tree-list-item.model';
import 'rxjs/add/operator/switchMap';
import { NavBarService } from '../../services/nav-bar.service';
import { PrestatieService } from '../../services/prestatie.service';

@Component({
  selector: 'app-target',
  templateUrl: './target.component.html',
  styleUrls: ['./target.component.scss']
})
export class TargetComponent implements OnInit {
  indicators: any;
  achievements: any[] = [];
  priorityAchievements: any[] = [];
  connectedParties: any[] = [];
  progressEmoji: string[] = ['/assets/img/icon-smiley-red.svg', '/assets/img/icon-smiley-orange.svg', '/assets/img/icon-smiley-green.svg'];
  navbarData: any = { title: '-', color: 1 };
  target: any;
  navbarLoaded: boolean;
  targetLoaded: boolean;
  navbarDone: boolean;
  ready: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: TargetService,
    private NavBarService: NavBarService,
    private PrestatieService: PrestatieService
  ) { }

  updateNavBar(a: any) {

    this.navbarData = this.NavBarService.getData().getValue();
    this.navbarData.title = `${a.Weergavenummer}. ${a.Tekst}`;
    this.navbarData.crumbs.push({
      text: `${a.Weergavenummer}. ${a.Tekst}`,
      link: `/programma/${a.id}/beleidsdoel/${a.id}`,
      active: true
    });
    this.navbarData.crumbs[1].active = false;
    this.navbarDone = true;
    this.NavBarService.setData(this.navbarData);
  }

  ngOnInit() {

    this.route.params
      .switchMap((params: Params) => this.service.get(+params['bid']))
      .subscribe((a) => {
        this.target = a[0];
        const that = this;

        this.targetLoaded = true;
        setTimeout(()=>{
          that.updateNavBar(a[0]);
        }, 50);

      });


    // Load indicators
    this.route.params
      .switchMap((params: Params) => this.service.getIndicators(+params['bid']))
      .subscribe((a) => {
        this.indicators = a;

        this.ready = true;
      });

    // Load achievements
    this.route.params
      .switchMap((params: Params) => this.PrestatieService.get(+params['bid']))
      .subscribe((a) => {

        for (let index = 0; index < a.length; index++) {
          if (a[index].type === 1) {
            this.priorityAchievements.push(a[index]);
          } else if (a[index].type === 0) {
            this.achievements.push(a[index]);
          } else {
            this.connectedParties.push(a[index]);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/target/target.component.ts